import { Injectable } from '@angular/core';
import { getLocaleCurrencySymbol } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Contact } from '../contact';

import CONTENT_CL from '../content/content-cl.json';
import CONTENT_AR from '../content/content-ar.json';
import CONTENT_MX from '../content/content-mx.json';
import CONTENT_CO from '../content/content-co.json';
import CONTENT_PE from '../content/content-pe.json';
import { CONTACTS } from '../content/contacts.json';


@Injectable()
export class LocaleService {
    contactList: Contact[] = CONTACTS;

    locale: string;
    symbol: string;
    currencyName: string;

    currentContact = this.contactList[0];
    currentCountryCode = this.currentContact.country_code;

    contactSource: BehaviorSubject<Contact>;
    contactMessage: Observable<Contact>;

    TLD = 'ar'.toLowerCase(); // window.location.href.split('.')[2].split('/')[0].toLowerCase();

    selectorGTM = {
        GTMcl: 'GTM-WBPLKNX',
        // GTMco: '',
        // GTMpe: ''
    };

    selectorGtag = {
        clGtag: 'UA-86671316-3',
        //coGtag: '',
        //peGtag: ''
    };

    constructor(
        private http: HttpClient,
    ) {
        this.changeContacts();
        this.locale = this.getLocale(this.TLD);
        this.symbol = getLocaleCurrencySymbol(this.locale);
        // this.currencyName = getLocaleCurrencyName(this.locale);
        this.currentCountryCode = this.TLD;
        this.currentContact = this.getContact();
        this.contactSource = new BehaviorSubject<Contact>(this.currentContact);
        this.contactMessage = this.contactSource.asObservable();
    }

    changeContacts(): void {
        const contactChile = this.contactList.find(x => x.country === 'Chile');
        contactChile.main_phone = '+56 2 2583 0965';
        contactChile.main_phone_href = '+56225830965';
        const contactMexico = this.contactList.find(x => x.country === 'México');
        contactMexico.main_phone = '+52 55 9435 6055';
        contactMexico.main_phone_href = '+525594356055';
        const contactArgentina = this.contactList.find(x => x.country === 'Argentina');
        contactArgentina.main_phone = '+54 11 5235 7173';
        contactArgentina.main_phone_href = '+54115237173';
        const contactColombia = this.contactList.find(x => x.country === 'Colombia');
        contactColombia.main_phone = '+57 601 580 4959';
        contactColombia.main_phone_href = '+576015804959';
    }

    updateContact(contact): void {
        this.contactSource.next(contact);
    }

    getMessage(): Observable<Contact> {
        return this.contactMessage;
    }

    getContact(): Contact {
        return this.contactList.filter(c => c.country_code === this.currentCountryCode)[0];
    }

    getLocale(tld: string): string {
        const TLD = tld.toLowerCase();
        switch (TLD) {
            case 'net':
                return 'en-US';
            case 'cl':
            case 'ar':
            case 'mx':
            case 'ec':
            case 'co':
            case 'pe':
                return 'es-' + (TLD.toUpperCase());
            default:
                return 'es-CL';
        }
    }
    getContent() {
        switch (this.locale) {
            case 'es-PE':
                return CONTENT_PE;
            case 'es-CO':
                return CONTENT_CO;
            case 'es-MX':
                return CONTENT_MX;
            case 'es-AR':
                return CONTENT_AR;
            default:
                return CONTENT_CL;
        }
    }

    getGTM(): string {
        let element: string;
        switch (this.locale) {
            // case 'es-CO':
            //     element = this.selectorGTM.GTMco;
            //     break;
            // case 'es-PE':
            //     element = this.selectorGTM.GTMpe;
            //     break;
            // case 'es-MX':
            //     break;
            // case 'es-AR':
            //     break;
            case 'es-CL':
                element = this.selectorGTM.GTMcl;
                break;
            default:
                element = '';
        }
        return element;
    }
    //Selection Google Analytics ID
    getGtag(): string {
        let element: string;
        switch (this.locale) {
            // case 'es-CO':
            //     element = this.selectorGtag.coGtag;
            //     break;
            // case 'es-PE':
            //     element = this.selectorGtag.peGtag;
            //     break;
            // case 'es-MX':
            //     break;
            // case 'es-AR':
            //     break;
            case 'es-CL':
                element = this.selectorGtag.clGtag;
                break;
            default:
                element = '';
        }
        return element;
    }
}
